<panel width="520">
  <menu always-visible>
    <menuitem (click)="createReasonCategory()">{{ 'reason.create-new-category' | translate }}</menuitem>
  </menu>
  <h1>{{ 'reason.list-reasons' | translate }}</h1>

  @if (!reasons || !reasonCategories) {
    <skeletons [defaultSkeletons]="6" />
  }
  @if (reasons && reasonCategories) {
    <div scrollable>
      <ng-template #reasonsList let-reasons="reasons" let-categoryId="categoryId">
        @if (categoryId) {
          <h2>{{ getCategoryName(categoryId) }}</h2>
        }
        <list-view [emptyLabel]="'reason.reason-list.reason-list-empty-label'">
          <header [hidden]="true" defaultSort="ascending">{{ 'general.name' | translate }}</header>
          <row *listData="let reason from reasons" [highlighted]="selectedReason?.id == reason.id" (action)="selectedReason = reason">
            <column>{{ reason.name }}</column>
            <column align-right><icon (click)="deleteReason(reason)" type="trash-alt" /></column>
          </row>
        </list-view>
      </ng-template>
      @for (group of reasonsByKey | keyvalue: originalOrder; track group) {
        <ng-container *ngTemplateOutlet="reasonsList; context: { reasons: group.value, categoryId: group.key }" />
      }
    </div>
  }
  <section>
    <button [loader]="false" (click)="createNewReason()">{{ 'reason.create' | translate }}</button>
  </section>
</panel>

@if (selectedReason) {
  <view-reason [reason]="selectedReason" />
}
